import type {
	FertilizationPlanAdvice,
	MaintenanceFormData,
	MaintenanceStartPayload,
} from '../types';

const NONE_VALUE = 'none';

export const buildMaintenanceStartPayload = (
	form: MaintenanceFormData
): MaintenanceStartPayload => {
	const isDynamic = form.parcellingType === 'dynamic';
	const payload: MaintenanceStartPayload = {
		name: form.name.trim(),
		propId: form.prop,
		areaId: form.area,
		sectorsId: form.sectors,
		soilAnalysisId: form.soilAnalysis,
		plantingAdviceId:
			!form.plantingAdvice || form.plantingAdvice === NONE_VALUE ? null : form.plantingAdvice,
		cropStage: form.cropStage as FertilizationPlanAdvice['cropStage'],
		productivity: form.cropStage === 'growth' ? null : Number(form.productivity) || 0,
		parcellingId: form.parcelling,
		parcellingType: isDynamic ? 'dynamic' : 'fixed',
	};

	if (isDynamic) {
		payload.floweringDate = form.floweringDate;
	} else {
		payload.floweringMonth = form.floweringMonth;
	}

	return payload;
};
